<template>
  <div class="article-content-wrapper">
    <div class="article-body-wrapper">
      <field-body ref="articleBody"  :body="node.body" :node="node" :bodyOptions="bodyOptions"></field-body>
    </div>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import isEmpty from 'lodash/isEmpty'

  import FieldBody from 'components/node/fields/Body.vue'

  export default {
    name: 'article-default-body',
    props: ['nid', 'cover'],
    components: {
      FieldBody,
    },
    computed: {
      node() {
        return this.$store.getters.node(this.nid)
      },
      chart() {
        // Temp chart
        return {
          options: {
            maintainAspectRatio: false,
            display: true,
            text: 'Chart.js Bar Chart - Stacked',
            responsive: true,
            scales: {
              xAxes: [{
                categorySpacing: 0,
                barPercentage: 1.5,
              }],
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1',
              }],
            },
          },
          message: 'Hello World',
          labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
          datasets: [{
            label: 'Data One',
            backgroundColor: '#FC2525',
            data: [40, 39, 10, 40, 39, 80, 40],
          }, {
            label: 'Data Two',
            backgroundColor: '#05CBE1',
            data: [60, 55, 32, 10, 2, 12, 53],
          }],
        }
      },
    },
    methods: {
      appendChart() {
        const chartDoms = get(this, '$refs.chart.$el')
        if (chartDoms) {
          const chartWrappers = document.querySelectorAll('.node-type-article .article-body .chart')
          if (!isEmpty(chartWrappers)) {
            [].forEach.call(chartWrappers, (targetElement) => {
              // chartDoms.classList.remove('hidden-xs-up')
              targetElement.appendChild(chartDoms)
            })
          } else {
            chartDoms.parentElement.removeChild(chartDoms)
          }
        }
      },
    },
    data() {
      return {
        bodyOptions: {
          countDown: true,
          photoOverlay: true,
          hideParagraphArrow: true,
          inlineNewsletter: false,
        },
      }
    },
  }
</script>



<style lang="scss" scoped>
  .article-content-wrapper {
    font-size: rem-calc(18);
    line-height: rem-calc(26);
    padding-top: rem-calc(40);
    max-width: rem-calc(700);
    margin: auto;
    @include respond-to('mobile') {
      padding-left: rem-calc($mobile-article-gutter);
      padding-right: rem-calc($mobile-article-gutter);
    }
  }

  .article-body-wrapper {
    width: 100%;
  }

  .article-subheading {
    position: relative;
    @include respond-to('desktop') {
      font-size: rem-calc(24);
      line-height: rem-calc(34);
    }
  }

  .share-buttons-wrapper .share-button svg{
    fill: $rose;
  }

  .tags-wrapper {
    padding: rem-calc(25 7);
    border-top: 1px solid $manatee;
  }

  .article-body{
    .article-body-text{
      div{
        p {
          margin-top: 0;
          margin-bottom: rem-calc(16);
        }
      }
      &:first-child{
        div{
          p {
            margin-top: 0;
          }
        }
      }
      p {
        @include respond-to('desktop') {
          font-size: rem-calc(18);
          line-height: rem-calc(30);
        }
      }
    }
  }

  .tags-wrapper{
    position: relative;
  }


</style>



// WEBPACK FOOTER //
// PageBody.vue?3e1dc470